import { getAnswer } from '@/utils/onboardingStorage'
import { useTranslation } from 'react-i18next'

export default function ThankYouPage() {
  const { t } = useTranslation()
  const role = getAnswer('role')?.answer || 'your role'
  const supportEmail =
    import.meta.env.VITE_SUPPORT_EMAIL || 'acri@app-studio.ai'

  return (
    <div className="bg-app-bg fixed inset-0 z-[300] flex items-center justify-center">
      <div
        className="flex w-[90%] max-w-[400px] flex-col items-center p-7 text-center"
        style={{ animation: 'screenIn 0.5s ease' }}
      >
        <div className="bg-accent/20 mb-4 flex h-20 w-20 items-center justify-center rounded-full">
          <span className="text-accent text-3xl">✓</span>
        </div>

        <h2 className="text-primary mt-4 mb-2.5 font-serif text-[1.4rem] leading-snug font-normal">
          {t('pages.thankYou.title', { defaultValue: 'Welcome to ACRI' })}
        </h2>

        <p className="text-muted mb-6 text-[0.88rem] leading-relaxed">
          {t('pages.thankYou.body', {
            defaultValue:
              "Your AI exposure report for {{role}} is being prepared. You'll receive your full task-by-task analysis shortly.",
            role,
          })}
        </p>

        <div className="mb-6 inline-flex items-center gap-2 rounded-full bg-[rgba(75,191,138,0.12)] px-5 py-2.5 text-[0.82rem] font-semibold text-[#2D8A5E]">
          <span className="flex h-[22px] w-[22px] items-center justify-center rounded-full bg-[#4BBF8A] text-[0.65rem] font-bold text-white">
            ✓
          </span>
          {t('pages.thankYou.refundBadge', {
            defaultValue: '14-day money-back guarantee',
          })}
        </div>

        <p className="text-muted mb-6 text-[0.88rem] leading-relaxed">
          {t('pages.thankYou.contactText', {
            defaultValue: 'Questions? Reach out anytime.',
          })}
        </p>

        <a
          href={`mailto:${supportEmail}`}
          className="text-primary hover:border-accent hover:text-accent mb-6 inline-block border-b-2 border-[#1a1a1a] pb-px font-bold no-underline transition"
        >
          {supportEmail}
        </a>
      </div>

      <style>{`
        @keyframes screenIn {
          from { opacity: 0; transform: translateX(60px); }
          to { opacity: 1; transform: translateX(0); }
        }
      `}</style>
    </div>
  )
}
